import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import {
  Table,
  Pagination,
  Tooltip,
  Input,
  DatePicker,
  Select,
  Modal,
} from 'components';
import {
  CleanIcon,
  TrashIcon,
  EditIcon,
  AddIcon,
  ViewIcon,
  CommentIcon,
} from 'assets/icons';
import moment from 'moment';
import { GeneralService, PreparationService, RevisionService } from 'services';
import ModalView from './modal-view';
import ViewComments from './view-comments';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const INITIAL_STATE = {
  search: '',
  area_id: '',
  document_id: '',
  state_id: '',
  status: '',
  since: '',
  until: '',
};

const STATUS_OPTIONS = [
  { id: Constants.PREPARATION_STATUS.PENDING, name: 'En elaboración' },
  { id: Constants.PREPARATION_STATUS.FINISHED, name: 'Finalizada' },
];

class Preparation extends React.Component<Props> {
  timer: any = undefined;

  state = {
    header: [
      'ID Orden',
      'Fecha',
      'Area legal',
      'Tipo de\n Documento',
      'Precio\n a pagar',
      'Cliente',
      'C.I',
      'Ubicación',
      'Ciudad',
      'Abogado',
      'Inpre',
      'Estatus',
      'Acciones',
    ],
    form: INITIAL_STATE,
    data: [],
    page: 1,
    last_page: 1,
    areas: [],
    documents: [],
    states: [],
    status: STATUS_OPTIONS,
    item: null,
    visible: false,
    visible_comments: false,
  };

  async componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Elaboración de Documentos',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.getSelects();
    this.load();
  }

  load = async (withoutLoading: boolean = false) => {
    const res: any = await PreparationService.admin.get({
      withoutLoading,
      page: this.state.page,
      ...this.state.form,
      since:
        this.state.form.since &&
        moment(this.state.form.since).format('YYYY-MM-DD'),
      until:
        this.state.form.until &&
        moment(this.state.form.until).format('YYYY-MM-DD'),
    });
    this.setState({
      data: res.rows,
      last_page: res.count,
    });
  };

  getSelects = async () => {
    const res: any = await GeneralService.getSelects({
      user_id: this.props.user?.id,
      area: true,
      state: true,
    });

    this.setState({
      areas: res.areas || [],
      states: res.states || [],
    });
  };

  getDocuments = async (area_id: string) => {
    const res: any = await PreparationService.getDocumentsByArea({
      area_id,
      withoutLoading: true,
    });

    this.setState({ documents: res.documents || [] });
  };

  getCities = async (state_id: string) => {
    const res: any = await GeneralService.getCities({
      state_id,
      withoutLoading: true,
    });

    this.setState({ cities: res.cities || [] });
  };

  loadComments = async (withoutLoading: boolean = false) => {
    const res: any = await PreparationService.viewComments({
      /* @ts-ignore */
      preparation_id: this.state.item?.id,
      withoutLoading,
    });

    return res;
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
        page: 1,
      },
      () => this.load(true),
    );
  };

  edit = (e: any, item: any) => {
    e.preventDefault();
    this.setState({
      visible: true,
      item,
    });
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  view = (e: any, item: any) => {
    e.preventDefault();
    this.setState({
      item,
      visible: true,
    });
  };

  onOpenComments = (e: any, item: any) => {
    e.preventDefault();
    this.setState({
      visible_comments: true,
      item,
    });
  };

  onCloseComments = (load: boolean = false) => {
    this.setState(
      {
        visible_comments: false,
        item: null,
      },
      () => load && this.load(true),
    );
  };

  onClose = () => {
    this.setState({
      visible: false,
      item: null,
    });
  };

  getColor = (item: any) => {
    switch (item.status) {
      case Constants.PREPARATION_STATUS.PENDING:
        return Colors.blueTable;
        break;
    }
  };

  render() {
    const { visible, visible_comments } = this.state;

    return (
      <div id="admin-preparation">
        <Modal
          className="modal-view-revision"
          visible={visible}
          title="Elaboración documental"
          onClose={() => this.onClose()}
        >
          <ModalView item={this.state.item} onClose={() => this.onClose()} />
        </Modal>

        <Modal
          className="modal-comments"
          visible={visible_comments}
          title="Comentarios"
          onClose={() => this.onCloseComments()}
        >
          {/* @ts-ignore */}
          <ViewComments loadComments={() => this.loadComments()} />
        </Modal>

        <div className="row-filter row">
          <div className="col-md-3">
            <Input
              value={this.state.form.search}
              name="search"
              placeholder="Nombre, ID de la orden"
              label="Buscar"
              className="input-table"
              onSubmit={() => this.load()}
              onChange={(e: any) => {
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                  this.load(true);
                }, 1000);
                this.change(e);
              }}
            />
          </div>
          <div className="col-md-2">
            <Select
              color="white"
              placeholder="Seleccionar"
              label="Area legal"
              name="area_id"
              onChange={(e: any) =>
                this.change(e, async () => {
                  this.getDocuments(e.target.value);
                  this.load(true);
                })
              }
              value={this.state.form.area_id}
              options={this.state.areas.map((item: any) => {
                return {
                  value: item.id,
                  label: item.name,
                };
              })}
            />
          </div>
          <div className="col-md-2">
            <Select
              color="white"
              placeholder="Seleccionar"
              label="Tipo de tramite"
              name="document_id"
              onChange={(e: any) =>
                this.change(e, async () => {
                  this.load(true);
                })
              }
              value={this.state.form.document_id}
              options={this.state.documents.map((item: any) => {
                return {
                  value: item.id,
                  label: item.name,
                };
              })}
            />
          </div>
          <div className="col-md-2">
            <Select
              color="white"
              placeholder="Seleccionar"
              label="Estado"
              name="state_id"
              onChange={(e: any) =>
                this.change(e, async () => {
                  this.load(true);
                })
              }
              value={this.state.form.state_id}
              options={this.state.states.map((item: any) => {
                return {
                  value: item.id,
                  label: item.name,
                };
              })}
            />
          </div>
          <div className="col-md-2">
            <Select
              color="white"
              placeholder="Seleccionar"
              label="Estatus"
              name="status"
              onChange={(e: any) =>
                this.change(e, async () => {
                  this.load(true);
                })
              }
              value={this.state.form.status}
              options={this.state.status.map((item: any) => {
                return {
                  value: item.id,
                  label: item.name,
                };
              })}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-2">
            <DatePicker
              label="Desde"
              placeholder="Desde"
              onChange={(text: string) => {
                this.change(
                  {
                    target: {
                      value: text,
                      name: 'since',
                    },
                  },
                  () => this.load(true),
                );
              }}
              value={this.state.form.since}
            />
          </div>
          <div className="col-md-2">
            <DatePicker
              label="Hasta"
              placeholder="Hasta"
              onChange={(text: string) => {
                this.change(
                  {
                    target: {
                      value: text,
                      name: 'until',
                    },
                  },
                  () => this.load(true),
                );
              }}
              value={this.state.form.until}
            />
          </div>
          <div className="col-md-1">
            {this.state.form != INITIAL_STATE && (
              <button className="btn btn-clean" onClick={() => this.reset()}>
                <img src={CleanIcon} />
              </button>
            )}
          </div>
        </div>

        <Table
          title="Revisión Documental"
          data={this.state.data.length}
          header={this.state.header}
          rightAlign={[12]}
        >
          {this.state.data.map((i: any, index: number) => {
            return (
              <tr key={index}>
                <td>{i.number_format}</td>
                <td>{moment(i.created_at).format('DD-MM-YYYY')}</td>
                <td>{i.area?.name}</td>
                <td>{i.document?.name}</td>
                <td>{Globals.formatMiles(i?.price)}</td>
                <td>{i.user?.full_name}</td>
                <td>{i.user?.full_document || '-'}</td>
                <td>{i.state?.name || '-'}</td>
                <td>{i.city?.name || '-'}</td>
                <td>{i.lawyer?.full_name || '-'}</td>
                <td>{i.lawyer?.lawyer_document || '-'}</td>
                <td>
                  <div
                    className="container-status"
                    style={{ color: this.getColor(i) }}
                  >
                    <p>
                      {i.status === Constants.PREPARATION_STATUS.PENDING
                        ? 'En elaboración'
                        : 'Finalizada'}
                    </p>
                  </div>
                </td>
                <td className="text-right">
                  <Tooltip title="Comentarios">
                    <a
                      className="link-icon comment"
                      href="#"
                      onClick={(e: any) => this.onOpenComments(e, i)}
                    >
                      <img src={CommentIcon} />
                    </a>
                  </Tooltip>

                  <Tooltip title="Ver">
                    <a
                      className="link-icon"
                      href="#"
                      onClick={(e: any) => this.view(e, i)}
                    >
                      <img src={ViewIcon} />
                    </a>
                  </Tooltip>
                </td>
              </tr>
            );
          })}
        </Table>

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={async (page: number) => {
            await this.setState({
              page: page,
            });
            this.load();
          }}
        />
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(Preparation);
